
import Carrucel from '../components/carrucel/Carrucel';
import Productos from '../components/productos/Productos';
import SobreNosotros from '../components/sobreNosotros/SobreNosotros';

const Home = () => {
    return <>
        <Carrucel />
        <Productos />
        <SobreNosotros />
    </>
}


export default Home;